export default __webpack_public_path__ + "static/media/tasks-grey.d116fa5c.svg";